import autoComplete from "@tarekraafat/autocomplete.js";

class MovieStreamingAutocomplete {
	constructor() {
		this.version = "10.2.9"; // autoComplete.js version
		this.request_url = "/streaming/autocomplete/";
		this.input_name = "#_streaming-search";
		this.results_id = "_search_streaming_result_list";
		this.close_button_id = "_streaming-search-close";
	}

	init() {
		const streamingAutoCompleteJS = new autoComplete({
			selector: this.input_name,
			debounce: 500,
			threshold: 3,
			data: {
				src: async (query) => {
					let url = `${this.request_url}?term=${encodeURIComponent(query)}`;
					const cat_selected = document.querySelector(this.input_name).dataset
						.ct;
					const platform_id = document.querySelector(this.input_name).dataset
						.pl;
					if (cat_selected) {
						url = `${url}&ct=${encodeURIComponent(cat_selected)}`;
					}
					if (platform_id) {
						url = `${url}&pl=${encodeURIComponent(platform_id)}`;
					}
					try {
						const source = await fetch(url, {
							headers: {
								"X-Requested-With": "XMLHttpRequest",
							},
						});
						const data = await source.json();
						return data;
					} catch (error) {
						return error;
					}
				},
				cache: false,
				keys: ["title"],
			},
			resultsList: {
				element: (list, data) => {
					list.setAttribute("id", this.results_id);
					list.setAttribute("aria-label", "Search");
					list.setAttribute("tabindex", "-1");
					if (!data.results.length) {
						const result = document.createElement("li");
						result.setAttribute("class", "autoComplete_result");
						result.setAttribute("tabindex", "1");
						result.innerHTML = `
              <p class="p-3 m-0">Non ci sono risultati per "${data.query}"</p>
            `;
						list.appendChild(result);
					}
					this.appendCloseButton();
				},
				destination: this.input_name,
				position: "afterend",
				tag: "ul",
				noResults: true,
				class: "autoComplete_list",
			},
			resultItem: {
				element: (element, data) => {
					const result = data.value;
					element.innerHTML = `
                <a class="media d-flex align-items-center gap-2 p-2" href="${result.link}">
                  <div class="media-img flex-shrink-0">
                    <img class="h-100 w-100" src="${result.image_lo}">
                  </div>
                  <div class="media-body flex-grow-1 d-flex flex-column align-items-start">
                    <h5 class="mt-0 mb-1 fw-bold lh-1">${result.title}</h5>
                    <p class="search-entry-labels m-0 mb-1 text-truncate d-inline">${result.category} | ${result.date}</p>
                    <p class="search-entry-abstract m-0">${result.description}</p>
                  </div>
                </a>`;
				},
				tag: "li",
				class: "autoComplete_result",
			},
		});
	}

	resetSearch(section) {
		document.querySelector(this.input_name).value = "";
		// placeholder
		let search_placeholder = "";
		if (typeof section === "undefined") {
			search_placeholder = document
				.querySelector(this.input_name)
				.getAttribute("placeholder");
		} else {
			const platform = document.querySelector(this.input_name).dataset.plname;
			search_placeholder = `Cerca ${section} in streaming`;
			if (platform) {
				search_placeholder = `${search_placeholder} su ${platform} ...`;
			} else {
				search_placeholder = `${search_placeholder} ...`;
			}
		}
		document
			.querySelector(this.input_name)
			.setAttribute("placeholder", search_placeholder);
	}

	appendCloseButton() {
		if (!!document.querySelector(`#${this.close_button_id}`) === false) {
			const $results = document.querySelector(`#${this.results_id}`);
			const $close_button = document.createElement("li");
			$close_button.classList.add("autoComplete_result_close");
			$close_button.innerHTML = `
        <span id="${this.close_button_id}" class="btn-close-ui">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <path d="M23.954 21.03l-9.184-9.095 9.092-9.174-2.832-2.807-9.09 9.179-9.176-9.088-2.81 2.81 9.186 9.105-9.095 9.184 2.81 2.81 9.112-9.192 9.18 9.1z" />
          </svg>
        </span>
      `;
			$results.insertBefore($close_button, $results.firstChild);
			document
				.querySelector(`#${this.close_button_id}`)
				.addEventListener("click", () => {
					const section = document.querySelector("#_section_toggle");
					if (section) {
						const key = section.value;
						this.resetSearch(key.replace("-", " "));
					} else {
						this.resetSearch();
					}
				});
		}
	}
}

function ready(fn) {
	if (document.readyState !== "loading") {
		fn();
	} else {
		document.addEventListener("DOMContentLoaded", fn);
	}
}

ready(() => {
	let streaming_autocomplete;
	if (document.querySelector("#_streaming-search")) {
		streaming_autocomplete = new MovieStreamingAutocomplete();
		streaming_autocomplete.init();
	}
	// Archive filters
	// --------------------------------------------------
	if (document.querySelector("#_section_toggle")) {
		document
			.querySelector("#_section_toggle")
			.addEventListener("change", function () {
				const key = this.value;
				// genres
				const genre_filters = document.querySelectorAll("._genre_filters");
				if (genre_filters.length) {
					for (const el of genre_filters) {
						el.style.display = "none";
					}

					document.querySelector(`#_${key}_filter`).style.display = "block";
				}
				// ctype
				const ct = `${key.replace("-", "")}.${key.replace("-", "")}`;
				document.querySelector(streaming_autocomplete.input_name).dataset.ct =
					ct;
				// reset autocomplete
				streaming_autocomplete.resetSearch(key.replace("-", " "));
			});
	}
});
